export var FormStyles = function () {
    return {
        multiStepWrapper: function (downMD, asMultiStep) { return ({
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: downMD ? "column" : "row",
            p: asMultiStep ? 2 : 0,
        }); },
        singleStepWrapper: {
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
        },
    };
};
